module.exports = __webpack_public_path__ + "static/junior-6-791eef90614afc38cc6c125ad3b57222.png";